import React, { Component } from "react";
import { Link } from "react-router-dom";
class SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [
        {
          id: 2,
          text01:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          text02:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.",
        },
        {
          id: 3,
          text01:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          text02:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.",
        },
        {
          id: 4,
          text01:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          text02:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.",
        },
        {
          id: 5,
          text01:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          text02:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.",
        },
      ],
    };
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className="span_1_of_6 bg-f7f">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={60}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 10px 0 43px"
                data-mobilemargin="0 15px 0 15px"
              >
                <div className="themesflat-headings style-2 clearfix">
                  <div className="sup-heading">OD PRVIH NOGOMETNIH KORAKA</div>
                  <h2 className="heading font-size-28 line-height-39">
                    <img
                      src="../assets/img/logos/Sportter_logo.png"
                      width={250}
                    />
                  </h2>
                  <div className="sep has-width w80 accent-bg margin-top-20 clearfix" />
                  <p className="sub-heading margin-top-33 line-height-24">
                    Aplikacija koja je namijenjena mlađim uzrastima nogometaša i
                    koja u njihov svijet donosi iskustvo profesionalnih
                    nogometaša. Lige, rezultati, statistike, profil igrača,
                    treninzi, izazovi, bodovi...woooow ⚽️
                  </p>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={56}
                data-mobile={56}
                data-smobile={56}
              />
            </div>
            <div
              className="span_1_of_6 half-background "
              style={{
                backgroundImage: "url(../assets/img/apps/sportter-app.jpg",
              }}
            ></div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              ŠTO JE{" "}
              <img
                src="../assets/img/logos/Sportter_logo.png"
                alt="Sportter"
                width={95}
                style={{ margin: "0px 2px 1px 2px" }}
              />{" "}
              ?
            </h5>

            <p>
              Sportter je mobilna aplikacija namijenjena mlađem uzrastu
              nogometaša, trenenirama, klubovima i roditeljima koji prate razvoj
              i nogometno sazrijevanje svog djeteta. Na zabavan i dobro
              osmišljen način stavlja pred djecu izazove koji ih uče disciplini,
              radu i trudu kako bi postigli svoje osobne uspjehe.
              <br />
              Od prvih koraka pa do seniorskih nastupa, kroz aplikaciju se prate
              nogometni trenutci koji ostaju trajno zabilježeni kao posebna
              vrijednost i uspomena na jednog dana davne golove, pobjede i
              poraze. <br />O detaljima brojnih modularnosti možete saznati od
              našeg <u>Ante, voditelja prodaje</u> ali prije svega nogometnog
              igrača i zaljubljenika u ovaj sport.
              <br />
              <br />
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />

          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title no-letter-spacing">
              KOJE SU OSNOVNE FUNKCIONALNOSTI?
            </h5>
            <p>
              Na zabavan i jedinstven način želimo uvesti još više zabave, ranih
              navika, odgovornosti i poštivanja uloga klub - trener - roditelj -
              igrač.
            </p>
            <div
              className="themesflat-spacer clearfix"
              data-desktop={27}
              data-mobile={27}
              data-smobile={27}
            />
            <div className="themesflat-tabs style-2 title-w170 clearfix">
              <ul className="tab-title clearfix ">
                <li className="item-title active">
                  <span className="inner">IGRAČI</span>
                </li>
                <li className="item-title">
                  <span className="inner">VODITELJI ŠKOLA NOGOMETA</span>
                </li>
                <li className="item-title">
                  <span className="inner">TRENERI</span>
                </li>
                <li className="item-title">
                  <span className="inner">RODITELJI</span>
                </li>
                <li className="item-title">
                  <span className="inner">KLUBOVI</span>
                </li>
              </ul>
              <div className="tab-content-wrap clearfix">
                {/** 1 */}
                <div className="tab-content" key={1}>
                  <div className="item-content">
                    <p style={{ fontWeight: "600", fontSize: "18px" }}>
                      Sportter. ZBOG TEBE!
                    </p>
                    <p>
                      <br />
                      <b>Budi i ti dio #izazova</b>
                      <br />
                      Želiš saznati tko je bolji, ti ili prijatelj s treninga?
                      Tko može više tehnicirati ili pogoditi prečku s 20 metara?
                      Napravi challenge, izazovi prijatelje i pokreni zarazni
                      trend. Oni najbolji bit će nagrađeni brojnim nagradama. U
                      aplikaciji ćeš imati prijatelje i pratitelje, nalik onima
                      na Facebooku ili Instagramu, pa će tvoji rezultati i
                      sjajne vještine moći postati „viralne“.
                      <br />
                      <br />
                      <b>Profil profesionalca</b>
                      <br />
                      Tko ne bi želio imati vlastiti profil na profesionalnoj
                      aplikaciji gdje se može vidjeti koliko si zaista dobar
                      igrač? Na Sportter aplikaciji gradit ćeš svoj profil na
                      kojem će pisati klub u kojem nastupaš, visina, težina dob,
                      pozicija, tvoja statistika s utakmica i još mnogo toga!
                      Tako ćeš se moći usporediti sa svojim vršnjacima, ali i s
                      nogometašima prvih liga.
                      <br />
                      Moći ćeš pratiti i druge klubove i igrače, vidjeti tablice
                      svih natjecanja i još mnogo toga…
                      <br />
                      <br />
                      <b>Budi informiran</b>
                      <br />
                      Kad je trening? Utakmica? Gdje i kad trebamo doći,
                      točnije. Tatu zanima može li se popiti kava u tom klubu
                      prije početka utakmice. Sportter nudi mnoge informacije
                      što ga čini boljim od svega što si do sad vidio!
                      <br />
                      <br />
                      <b>Od prvih koraka do profesionalca</b>
                      <br />
                      Tvoj profil na Sportteru počinje se graditi od trenutka
                      prijave na aplikaciju. Potrudi se da budeš dobro
                      predstavljen, s točnim i uvijek novim podacima. Tako ćeš
                      najbolje prezentirati sebe i svoj nogometni put.
                    </p>
                  </div>
                </div>
                {/** 2 */}
                <div className="tab-content" key={2}>
                  <div className="item-content">
                    <p style={{ fontWeight: "600", fontSize: "18px" }}>
                      OSIGURAJ NAJBOLJE ZA NOGOMETNU ŠKOLU!
                    </p>
                    <br />
                    <b>Neka stvari budu zabavnije!</b>
                    <p>
                      Izaberi Sportter aplikaciju za bolju i efikasniju
                      organizaciju nogometne škole. Kroz aplikaciju u svakom
                      trenutku možeš provjeriti i uređivati sve aktualnosti, a
                      svojim kolegama trenerima i igračima osigurati moderan i
                      zabavan pristup vođenju nogometnog kluba!
                      <br />
                      <br />
                      <b>Bolji pregled aktivnosti</b>
                      <br />
                      Aplikacija nudi uvid u cijelu organizaciju čiji si
                      voditelj. Raspoloživost trenera, plan treninga, dolaske
                      igrače, iskazivanje učinka kroz postotke i usporedbe,
                      raspored utakmica i ostalih tjednih aktivnosti… Sve to će
                      biti dostupno “na jedan klik” i nije teško zamisliti
                      situaciju u kojoj netko ima pitanja na koja imaš vrlo
                      precizan odgovor! Napravi takav iskorak!
                      <br />
                      <br />
                      <b>Upisi novih članova</b>
                      <br />
                      Ima li mjesta? Koji trener? Koliko je upisanih? U kojoj je
                      grupi Marko s kojim Ante ide u razred? Naravno da uz
                      Sportter znaš sve odgovore. Treba li naglasiti da se upit
                      šalje preko aplikacije? Uz Sportter nije teško biti bolji
                      od drugih klubova!
                      <br /> <br />
                      <b>Analize kao put u bolje rezultate</b>
                      <br />
                      Uvijek se može biti bolji, slažemo se. Svakim danom
                      trebamo poboljšati sve ono u čemu i nismo tako dobri.
                      Samo, što je to? Analize učinaka ključ su podizanja
                      kvalitete na viši nivo. Sportter se, stoga, s posebnom
                      pažnjom fokusira i na izradu analitičkih alata kroz koje
                      možeš saznati više nego što trenutno znaš o svom
                      kolektivu. Ok, opet je na vama da se poboljšavate, ali sa
                      Sportterom napravite prvi korak!
                      <br />
                    </p>
                  </div>
                </div>
                {/** 3 */}
                <div className="tab-content" key={3}>
                  <div className="item-content">
                    <p style={{ fontWeight: "600", fontSize: "18px" }}>
                      TRENER 21. STOLJEĆA
                    </p>
                    <br />
                    <b>Sportter - od trenera za trenere</b>
                    <p>
                      Posebna pažnja u razvoju Sporttera posvećena je trenerima
                      i izazovima s kojima se susreću svakodnevno. Imaj uvid u
                      sve aktivnosti, kao i pregled svih događanja svoje ekipe.
                      Kroz aplikaciju prati učestalost dolaska na treninge,
                      primi informacije o opravdanim i neopravdanim izostancima,
                      upiši bilješke s treninga koji su nužne za izradu
                      statistika, tvojih, internih, a zatim donesi odluke na
                      temelju činjenica!
                      <br /> <br />
                      <b>Uštedi vrijeme</b>
                      Kroz razne komunikacijske kanale informiraj svoje igrače i
                      roditelje, lakše komuniciraj tzv. servisne zadatke, a
                      mnoge one koje znamo da ne voliš, poput podsjetnika za
                      neplaćenu članarinu, organizaciju oko kupnje opreme,
                      prikupljanje novca za kotizacije i slično, olakšat će ti
                      Sportter!
                      <br />
                      <br />
                      <b>Prijateljske utakmice</b>
                      <br />
                      Organiziraj prijateljsku utakmicu! Jednostavno objavi na
                      svom profilu mjesto i vrijeme događaja, a drugi treneri će
                      to moći vidjeti na svom feedu. Nakon što netko označi da
                      je zainteresiran, preko aplikacije razmijenite kontakt i
                      dogovorite prijateljski susret vaših ekipa.
                      <br />
                      <br />
                      <b>Na koga računam?</b>
                      Tko je dostupan, a tko nije? Broj žutih kartona i
                      suspenzije? Znamo da pravi trener stalno nešto kombinira,
                      stoga odaberi i pravi alat za svoje kombinacije!
                      <br />
                      <br />
                      <b>Sportter - mreža trenera i igrača</b>
                      <br />
                      <br />
                      Znaš da je Marko brz i da Ivan prođe poligon sporije od
                      ostatka ekipe. Ali gdje su oni u odnosu na sve svoje
                      vršnjake? Razvili smo modul koji bi trebao dati odgovore
                      na ta pitanja. Modul pokazuje u koji postotak oni spadaju
                      u odnosu na generaciju. Možda Marko i nije toliko dobar, a
                      niti Ivan baš toliko brz. Samo činjenice!
                    </p>
                  </div>
                </div>
                {/** 4 */}
                <div className="tab-content" key={3}>
                  <div className="item-content">
                    <p style={{ fontWeight: "600", fontSize: "18px" }}>
                      RODITELJ. NAJVJERNIJI NAVIJAČ
                    </p>
                    <br />
                    <b>Jednostavno i zabavno</b>
                    <p>
                      Sportter omogućuje lakšu komunikaciju između roditelja,
                      igrača i trenera! Organizirajte se kroz chat, pratite
                      rasporede kroz modul za treninge, primajte notifikacije za
                      sve važne informacije.
                      <br />
                      <br />
                      <b>Profil koji stvara uspomene</b>
                      <br />
                      Vi pomažete u održavanju profila djeteta dodavanjem
                      sadržaja. Dodajte novu profilnu sliku, fotografiju
                      veselih, a i onih nešto manje veselih s turnira. Zapiši,
                      pofotkaj… zabilježi sve djetetove uspjehe, druženja i
                      dobre provode s ekipom, stvaraj nezaboravne uspomene kojih
                      će se jednog dana rado sjećati.
                      <br /> <br />
                      <b>Okušajte se kao sportski novinar ;)</b>
                      <br />
                      “Ljudi moji, je li to moguće? Ludnica! Što je ovo?” -
                      jeste spremni da postanete "sportski novinar"? Ostvarite
                      novu karijeru i postanite dio utakmice! ;-)
                      <br />
                      Na jednostavan način uređujte tijek događaja utakmice,
                      postave, izmjene i budite spremni za gooool!
                      <br /> <br />
                    </p>
                  </div>
                </div>
                {/** 5 */}
                <div className="tab-content" key={3}>
                  <div className="item-content">
                    <p style={{ fontWeight: "600", fontSize: "18px" }}>
                      TKO JE NAJBOLJI?
                    </p>
                    <br />
                    <b>Budite dio nogometne mreže Sportter</b>
                    <p>
                      Sportter je proizvod tvrtke CityX Apps. U suradnji s
                      nogometnim stručnjacima i trenerima kontinuirano radimo na
                      poboljšanju i novim funkcionalnostima na području
                      digitalizacije sporta. Sportter je mobilna aplikacija
                      dostupna za iPhone i Android uređaje koja je potpuno
                      besplatna za preuzimanje, i to u svom osnovnom obliku koji
                      nudi potpunu funkcionalnost. Sportter je namijenjen
                      organizaciji i radu s mlađim uzrastom nogometaša te
                      popularizaciji nogometa kroz klupski rad.
                      <br />
                      <br />
                      <b>Kako biti dio Sportter-a?</b>
                      <br />
                      Jednostavno, javite se prodajnom predstavniku u ime kluba.
                      Za inicijalni kontakt bitno je da se radi o osobi koja ima
                      pravo zastupanja kluba - trener, voditelj nogometne škole
                      ili predstavnik kluba.
                      <br />
                      <br />
                      <b>Naplata članarina</b>
                      <br />
                      Aplikacija Sportter donosi niz funkcionalnosti. Jedna od
                      njih je i sustav za naplatu članarina. Uz nekoliko klikova
                      roditelji može i putem aplikacije platiti svoje obveze,
                      provjeriti stanje duga, a samim time rasteretiti trenere
                      oko prikupljanja članarina.
                      <br />U slučaju neplaćenih članarina, notifikacijski
                      sustav (baš poput messengera), automatizirano šalje
                      upozorenja.
                      <br />
                      <br />
                      <b>Da li možemo istaknuti sponzore kluba?</b>
                      <br />
                      Da. Unutar aplikacije možete sadržaj prilagoditi klubu. Od
                      boja, grba pa do sponzora kluba. I sve to unutar
                      standardnog paketa i bez posebnih nadoplata
                      <br />
                      <br />
                      <b>Sigurnost i zaštita povjerljivih podataka</b>
                      <br />
                      Ova platforma predstavlja mrežu trenera i igrača. Podatci
                      o igraču su tajni i nedostupni svima osim ovlaštenim
                      osobama kluba. Rad s podatcima shvaćamo vrlo ozbiljno.
                      <br /> <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default SiteContent;
